const e = {
  base: "adyen-pe-divider"
};
export {
  e as DIVIDER_CLASS_NAMES
};
